import { createDraftSafeSelector } from "@reduxjs/toolkit";

const isShareAudienceModalOpen = state =>
  state.audienceSlice.isShareAudienceModalOpen;

export const isShareAudienceModalOpenSelector = createDraftSafeSelector(
  isShareAudienceModalOpen,
  state => state
);

export const selectedAudienceSelector = createDraftSafeSelector(
  state => state.audienceSlice.selectedAudience,
  state => state
);

export const shareAudienceSelector = createDraftSafeSelector(
  state => ({
    isValidateLoading: state.audienceSlice.isValidateLoading,
    isValidateSuccess: state.audienceSlice.isShareValidateEmailSuccess,
    validateError: state.audienceSlice.shareValidateEmailError,

    isShareAudienceLoading: state.audienceSlice.isShareAudienceLoading,
    isShareAudienceSuccess: state.audienceSlice.isShareAudienceSuccess,
    shareError: state.audienceSlice.shareError
  }),
  state => state
);
